import { render, staticRenderFns } from "./CardSpecification.vue?vue&type=template&id=0f1e9d07"
import script from "./CardSpecification.vue?vue&type=script&lang=js"
export * from "./CardSpecification.vue?vue&type=script&lang=js"
import style0 from "./CardSpecification.vue?vue&type=style&index=0&id=0f1e9d07&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports